import Device from './device';

const img = require('../../assets/images/apple.jpg');

export default class Apple extends Device {
  constructor(...params) {
    super(...params);

    this.loadedImage = img;
  }

  get type() {          // eslint-disable-line
    return 'apple';
  }

  get manufacturer() {  // eslint-disable-line
    return 'Apple';
  }

  // eslint-disable-next-line class-methods-use-this
  get authToken() {
    return window.platform && window.platform === 'ios' && window.hkEnabled === true;
  }

  link() {
    if (!window.platform || window.platform !== 'ios') {
      this.eventBus.emit('toggleAlert', {
        message: 'Open the PWR Lab app on your iPhone to connect with Apple.',
        messageSize: 'p',
      });
    } else {
      window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify({
        type: 'linkApple',
      }));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  unlink() {
    if (!window.platform || window.platform !== 'ios') {
      this.eventBus.emit('toggleAlert', {
        message: 'Open the PWR Lab app on your iPhone to disconnect your Apple account.',
        messageSize: 'p',
      });
    } else {
      window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify({
        type: 'unlinkApple',
      }));
      window.hkEnabled = false;
      window.location.reload();
    }
  }
}
